export var AgentStatusFilterOptions;
(function (AgentStatusFilterOptions) {
    AgentStatusFilterOptions[AgentStatusFilterOptions["ONLINE"] = 10] = "ONLINE";
    AgentStatusFilterOptions[AgentStatusFilterOptions["ACTIVE"] = 11] = "ACTIVE";
    AgentStatusFilterOptions[AgentStatusFilterOptions["BUSY"] = 60] = "BUSY";
    AgentStatusFilterOptions[AgentStatusFilterOptions["OFFLINE"] = 100] = "OFFLINE";
})(AgentStatusFilterOptions || (AgentStatusFilterOptions = {}));
//# sourceMappingURL=agent-status-filter-options.enum.js.map